<template>
  <v-row class="pt-5">
    <v-col cols="12">
      <h2 class="headline mb-4 yellow--text text--lighten-1">Language</h2>
    </v-col>
    <v-col cols="12">
      <h3 class="body-1 yellow--text text--lighten-2">
        Slang and nick names
      </h3>
    </v-col>
    <v-col cols="6">
      <results-list
        :title="content.exercise_culture_language.questions[0].title"
        :items="doc.matrix.q1"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="6">
      <results-list
        :title="content.exercise_culture_language.questions[1].title"
        :items="doc.matrix.q2"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="6">
      <results-list
        :title="content.exercise_culture_language.questions[2].title"
        :items="doc.matrix.q3"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="12">
      <h3 class="body-1 yellow--text text--lighten-2">
        Mannerisms
      </h3>
    </v-col>
    <v-col cols="6">
      <results-list
        :title="content.exercise_culture_language.questions[2].title"
        :items="doc.matrix.q4"
        inner-class="yellow--text"
      />
    </v-col>
    <v-col cols="6">
      <results-list
        :title="content.exercise_culture_language.questions[3].title"
        :items="doc.matrix.q5"
        inner-class="yellow--text"
      />
    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import ResultsList from "./ResultsList";

export default {
  name: "ResultsLanguage",
  components: {
    ResultsList,
  },
  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },
  data() {
    return {
      items: null,
      doc: null,
      admins: null,
      content: {},
      results: {
        q1: [],
        q2: [],
        q3: [],
        q4: [],
        q5: [],
        q6: [],
        q7: [],
        q8: [],
      },
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    id: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getExercise();
        }
      },
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  mounted() {},
  methods: {
    getExercise() {
      this.doc = null;
      let ref = fb.cultureLanguageExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            console.log("items", items);
            this.doc = items[0].doc;
          }
        })
        .catch(function() {});
    },

    getResults(doc) {
      this.pushToArray(doc.matrix.q1, "q1");
      this.pushToArray(doc.matrix.q2, "q2");
      this.pushToArray(doc.matrix.q3, "q3");
      this.pushToArray(doc.matrix.q4, "q4");
      this.pushToArray(doc.matrix.q5, "q5");
      this.pushToArray(doc.matrix.q6, "q6");
    },
    pushToArray(arr, model) {
      if (arr || arr.length > 0 || arr != undefined) {
        console.log(arr);
        arr.forEach((y) => {
          this.results[model].push(y);
        });
      }
    },
  },
};
</script>
